/**
 * Legacy Boolean Permission Map
 *
 * @deprecated Use granular RBAC permission checks via `checkPermission()` /
 * `hasAnyPermission()` / `hasAllPermissions()` from AuthContext instead.
 *
 * Retained for backward compatibility during migration to the new RBAC model.
 * Extracted from auth-context.tsx to keep that file under the 300-line standard.
 */

import type { UserRole, RolePermissions } from '@/types';

/** @deprecated Use granular RBAC permission checks instead. */
export const LEGACY_ROLE_PERMISSIONS: Record<UserRole, RolePermissions> = {
  // New roles
  super_admin: {
    canViewDashboard: true,
    canViewCustomers: true,
    canViewSubscriptions: true,
    canViewTransactions: true,
    canViewPaymentMethods: true,
    canViewInvoices: true,
    canExportData: true,
    canManageUsers: true,
  },
  admin: {
    canViewDashboard: true,
    canViewCustomers: true,
    canViewSubscriptions: true,
    canViewTransactions: true,
    canViewPaymentMethods: true,
    canViewInvoices: true,
    canExportData: true,
    canManageUsers: true,
  },
  normal_user: {
    canViewDashboard: true,
    canViewCustomers: true,
    canViewSubscriptions: true,
    canViewTransactions: true,
    canViewPaymentMethods: true,
    canViewInvoices: true,
    canExportData: false,
    canManageUsers: false,
  },
  finance_user: {
    canViewDashboard: true,
    canViewCustomers: true,
    canViewSubscriptions: true,
    canViewTransactions: true,
    canViewPaymentMethods: false,
    canViewInvoices: true,
    canExportData: true,
    canManageUsers: false,
  },
  developer: {
    canViewDashboard: true,
    canViewCustomers: true,
    canViewSubscriptions: true,
    canViewTransactions: true,
    canViewPaymentMethods: false,
    canViewInvoices: true,
    canExportData: false,
    canManageUsers: false,
  },
  // Legacy roles — kept for backward compatibility during migration
  support: {
    canViewDashboard: true,
    canViewCustomers: true,
    canViewSubscriptions: true,
    canViewTransactions: true,
    canViewPaymentMethods: true,
    canViewInvoices: true,
    canExportData: false,
    canManageUsers: false,
  },
  finance: {
    canViewDashboard: true,
    canViewCustomers: true,
    canViewSubscriptions: true,
    canViewTransactions: true,
    canViewPaymentMethods: false,
    canViewInvoices: true,
    canExportData: true,
    canManageUsers: false,
  },
  viewer: {
    canViewDashboard: true,
    canViewCustomers: true,
    canViewSubscriptions: true,
    canViewTransactions: true,
    canViewPaymentMethods: true,
    canViewInvoices: true,
    canExportData: false,
    canManageUsers: false,
  },
};
